// extracted by mini-css-extract-plugin
export default {"report_workspace":"ReportWorkspace_report_workspace__tabke"};